import Model from '@/models/Model'

export default class SlWholesaleDiscountFamily extends Model {
    resource() {
        return 'sl_wholesale_discount_family'
    }
}